import { connect } from 'react-redux';
import { IState } from '../../store';
import { closeEntryToShowSuccessModal } from '../../store/deal-rent';
import { EntryToShowSuccessModal } from './EntryToShowSuccessModal';

export function mapStateToProps(state: IState) {
  return {
    isOpen: state.dealRent.isEntryToShowSuccessModal,
  };
}

export const EntryToShowSuccessModalContainer = connect(mapStateToProps, { closeModal: closeEntryToShowSuccessModal })(
  EntryToShowSuccessModal,
);
